"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ImageWorkerImage {
    constructor(manager, id, src) {
        this.manager = manager;
        this.id = id;
        this.src = src;
    }
    set onError(f) {
        this._onError = f;
    }
    set onLoad(f) {
        this._onLoad = f;
    }
    cancel() {
        this.manager.cancel(this);
    }
    load(info) {
        if (this._onLoad) {
            this._onLoad(info);
        }
    }
    error(info) {
        if (this._onError) {
            this._onError(info);
        }
    }
}
exports.ImageWorkerImage = ImageWorkerImage;
//# sourceMappingURL=ImageWorkerImage.js.map